import React from 'react';

function MatchCard({ title, date, venue }) {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <h3 className="text-lg font-semibold">{title}</h3>
      <p>Date: {date}</p>
      <p>Venue: {venue}</p>
    </div>
  );
}

export default MatchCard;